import { CopilotPanelContentBase, CopilotPanelContext } from 'models/copilot/copilotBridge';

export class CopilotAnnualPlanContent extends CopilotPanelContentBase {
  public readonly context = CopilotPanelContext.AnnualPlan;

  // whether the scene offers Draft automation for the plan as a whole (isAutomationDraftingAvailable)
  constructor(public readonly canDraftAutomation: boolean = false) {
    super();
  }
}
